// extracted by mini-css-extract-plugin
export default {"cartList":"Cart_cartList__LMdUm","header":"Cart_header__pTcZb","total":"Cart_total__W1-dF","noItems":"Cart_noItems__R2aCJ"};